import { SPToBFIdMap } from "@hypexone/uicore";

// Sports Icons
import CricketIcon from "../../assets/icons/popular-sports-icons/cricket-icon.svg?react"
import FootballIcon from '../../assets/icons/popular-sports-icons/football-icon.svg?react'
import BasketballIcon from '../../assets/icons/popular-sports-icons/basketball-icon.svg?react'
import BaseballIcon from '../../assets/icons/popular-sports-icons/baseball-icon.svg?react'
import TennisIcon from '../../assets/icons/popular-sports-icons/tennis-icon.svg?react'
import IceHockeyIcon from '../../assets/icons/popular-sports-icons/icehockey-icon.svg?react'
import TableTennisIcon from '../../assets/icons/popular-sports-icons/table-tennis-icon.svg?react'
import KabaddiIcon from '../../assets/icons/popular-sports-icons/kabaddi-icon.svg?react'
import BinaryIcon from '../../assets/icons/popular-sports-icons/binary-icon.svg?react'
import VolleyballIcon from '../../assets/icons/popular-sports-icons/volleyball-icon.svg?react'
import DartsIcon from '../../assets/icons/popular-sports-icons/dart-icon.svg?react'
import HorseRacingIcon from '../../assets/icons/popular-sports-icons/horserace-icon.svg?react'
import GreyhoundIcon from '../../assets/icons/popular-sports-icons/greyhound-icon.svg?react'
import PoliticsIcon from '../../assets/icons/popular-sports-icons/politics-icon.svg?react'

export const headerGradient = "bg-header-gradient";

export const commonPaddingBottomForMobile = "pb-[65px] md:pb-1";

export const popularEventSportIconMap = {
    [SPToBFIdMap["sr:sport:21"]]: CricketIcon,
    [SPToBFIdMap["sr:sport:1"]]: FootballIcon,
    [SPToBFIdMap["sr:sport:2"]]: BasketballIcon,
    [SPToBFIdMap["sr:sport:3"]]: BaseballIcon,
    // [SPToBFIdMap["sr:sport:31"]]: badmintonIcon,
    [SPToBFIdMap["sr:sport:5"]]: TennisIcon,
    [SPToBFIdMap["sr:sport:4"]]: IceHockeyIcon,
    [SPToBFIdMap["sr:sport:20"]]: TableTennisIcon,
    [SPToBFIdMap["sr:sport:138"]]: KabaddiIcon,
    99990: BinaryIcon,
    "sr:sport:23": VolleyballIcon,
    sr_sport_23: VolleyballIcon,
    "sr:sport:22": DartsIcon,
    sr_sport_22: DartsIcon,
    "7": HorseRacingIcon,
    "4339": GreyhoundIcon,
    "2378961": PoliticsIcon,
    "1": FootballIcon,
    "2": TennisIcon,
    "4": CricketIcon,
    "7522": BasketballIcon,
    "7511": BaseballIcon,
    "99994": KabaddiIcon,
    other: CricketIcon,
    // ["sr:sport:117"]: mmaIcon,
  };